<template>
  <div>
    <div v-if="btnSpinAdminReview === false">
      <v-btn
      :color="ui.btnColor"
      icon v-if="data.size == 'icon'"
      @click="getAccess(data.tagd, data.tags)"
      flat dark>
        <v-icon :color="btn.Color"> {{btn.icon}} </v-icon>
      </v-btn>
      <v-btn
      :color="ui.btnColor"
      v-if="data.size == 'flat' || data.size == undefined"
      @click="getAccess(data.tagd, data.tags)"
      flat dark>
        <v-icon left :color="btn.Color"> {{btn.icon}} </v-icon>
          {{btn.title}}
      </v-btn>
    </div>
    <div v-else>
      <BtnSpin dark v-if="data.size == 'icon'" :btnSpec="btnInfo1"/>
      <BtnSpin dark v-if="data.size == 'flat'" :btnSpec="btnInfo2"/>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import BtnSpin from "@/frame/animation/components/BtnSpin";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import storeFunctions from "@/data/functions/mixins/storeFunctions.js";
import routerFunctions from "@/data/functions/mixins/routerFunctions.js";
import dataSources from "@/data/cloud/firebase/mixins/dataSources.js";
import getList from "@/data/cloud/firebase/mixins/getList.js";
export default {
  // eslint-disable-next-line
  mixins: [
    apptheme,
    getList,
    storeFunctions,
    routerFunctions,
    dataSources
  ],
  methods: {
    getAccess(tagd, tags) {
      this.btnSpinAdminReview = true;
      // eslint-disable-next-line
      this.getListAccess(tagd, tags);
    }
  },
  computed: {
    ...mapGetters(["getCurrentPage"]),
    btn() {
      let obj = {
        title: "",
        icon: "",
        color: ""
      };
      if (this.getCurrentPage === "/accesslist") {
        obj.title = "refresh";
        obj.icon = "refresh";
        obj.color = this.ui.btnColor;
      } else if (this.data.tag === "F1") {
        obj.title = "active users";
        obj.icon = "key";
        obj.color = this.ui.btnColor;
      } else if (this.data.tag === "G1") {
        if (this.data.tagd === "Z5") {
          obj.title = "Review";
          obj.icon = "fact_check";
          obj.color = this.ui.btnColor;
        } else if (this.data.tagd === "U1") {
          obj.color = this.ui.btnColor;
          if (this.getCurrentPage === "/userdash") {
            obj.title = "Access";
            obj.icon = "key";
          } else if (this.getCurrentPage === "/facilitydetail") {
            obj.title = "Active Users";
            obj.icon = "person";
          } else {
            if (this.data.tags === "C1") {
              obj.title = "Company Access";
              obj.icon = "account_balance";
            } else {
              obj.title = "Facility Access";
              obj.icon = "place";
            }
          }
        } else if (this.data.tagd === "C1") {
          obj.color = this.ui.btnColor;
          if (this.getCurrentPage === "/companydash") {
            obj.icon = "key";
            obj.title = "Active Users";
          } else if (this.getCurrentPage === "/companydetail") {
            obj.icon = "person";
            obj.title = "Active Users";
          } else if (this.getCurrentPage === "/companymanagement") {
            obj.icon = "person";
            obj.title = "Users";
          } else {
            if (this.data.tags === "X1") {
              obj.title = "Company Access";
              obj.icon = "account_balance";
            } else {
              obj.title = "Facility Access";
              obj.icon = "place";
            }
          }
        } else if (this.data.tagd === "F1") {
          obj.color = this.ui.btnColor;
          if (this.getCurrentPage === "/facilitydash") {
            obj.icon = "key";
            obj.title = "Active Users";
          } else if (this.getCurrentPage === "/facilitydetail") {
            obj.icon = "person";
            obj.title = "Active Users";
          } else if (this.getCurrentPage === "/facilitymanagement") {
            obj.icon = "person";
            obj.title = "Users";
          } else {
            if (this.data.tags === "X1") {
              obj.title = "Company Access";
              obj.icon = "account_balance";
            } else {
              obj.title = "Facility Access";
              obj.icon = "place";
            }
          }
        } else {
          obj = null;
        }
      } else {
        obj = null;
      }
      return obj;
    }
  },
  props: {
    data: {
      type: Object
    }
  },
  components: {
    BtnSpin
  },
  data() {
    return {
      valid: false,
      btnSpinAdminReview: false,
      btnInfo1: {
        color: "red",
        icon: "person",
        name: "add user",
        btnType: "icon"
      },
      btnInfo2: {
        color: "red",
        icon: "person",
        name: "add user",
        btnType: "flat"
      }
    };
  }
};
</script>
